// PdfExport.js

import html2pdf from "html2pdf.js";
import { message } from "antd";

export default function PdfExport(data) {
  console.log("PdfExport input data:", data);
  // Function to handle exporting to PDF using a custom HTML template
  const handleExportPDF = () => {
    if (!data) return;

    // Create a temporary div to hold the PDF content
    const pdfContent = document.createElement("div");
    pdfContent.style.padding = "20px";
    pdfContent.style.fontFamily = "Arial, sans-serif";
    pdfContent.style.fontSize = "12px";

    // Build the improved styled HTML content with full sectioned layout and enhanced styling
    pdfContent.innerHTML = `
      <div style="padding: 24px; font-family: Arial, sans-serif; font-size: 12px; color: #333;">
        <h1 style="text-align: center; font-size: 20px; color: #2e7d32; margin-bottom: 20px; border-bottom: 1px solid #ccc; padding-bottom: 8px;">
          Indigent Application Form 2024/2025
        </h1>

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Section A - Account Information</h2>
        <p style="margin: 8px 0;"><strong>Account Name:</strong> ${data.accountName ?? "N/A"}</p>
        <p style="margin: 8px 0;"><strong>Account Number:</strong> ${data.accountNumber ?? "N/A"}</p>
        <p style="margin: 8px 0;"><strong>Erf No:</strong> ${data.erfNo ?? "N/A"}</p>
        <p style="margin: 8px 0;"><strong>Prepaid Meter Number:</strong> ${data.prepaidMeter ?? "N/A"}</p>
        <p style="margin: 8px 0;"><strong>Date of Application:</strong> ${data.applicationDate ?? "N/A"}</p>
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Section B - Terms and Conditions</h2>
        <p style="white-space: pre-line; margin: 8px 0 16px 0;">${data.termsText ?? "Refer to official terms and conditions document."}</p>
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Personal Information</h2>
        <p style="margin: 8px 0;"><strong>ID Number:</strong> ${data.idNumber ?? "N/A"}</p>
        <p style="margin: 8px 0;"><strong>Full Name:</strong> ${data.firstNames ?? ""} ${data.surName ?? ""}</p>
        <p style="margin: 8px 0;"><strong>Gender:</strong> ${data.gender ?? "N/A"}</p>
        <p style="margin: 8px 0;"><strong>Deceased Status:</strong> ${data.deceasedStatus ?? "N/A"}</p>
        <p style="margin: 8px 0 16px 0;"><strong>Marital Status:</strong> ${data.maritalStatus ?? "N/A"}</p>
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Section C - Individuals Residing with the Applicant</h2>
        ${
          data.householdMembers && data.householdMembers.length
            ? `<ul style="margin: 8px 0 16px 20px; padding-left: 0;">${data.householdMembers.map((m) =>
                `<li style="margin-bottom: 6px;">${m.fullName ?? "N/A"} - ID: ${m.idNumber ?? "N/A"} - Age: ${m.age ?? "N/A"} - Gender: ${m.gender ?? "N/A"}</li>`
              ).join("")}</ul>`
            : "<p style=\"margin: 8px 0 16px 0;\">No household members listed.</p>"
        }
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Section D - Financial Information</h2>
        ${
          data.financialInfo && data.financialInfo.length
            ? `<table style="width:100%; border-collapse: collapse; margin: 8px 0 16px 0;" border="1">
                <thead>
                  <tr style="background-color: #e0e0e0;">
                    <th style="padding: 6px;">Source</th>
                    <th style="padding: 6px;">Husband</th>
                    <th style="padding: 6px;">Wife</th>
                    <th style="padding: 6px;">Adult Living with Parents</th>
                    <th style="padding: 6px;">Other</th>
                  </tr>
                </thead>
                <tbody>
                  ${data.financialInfo.map(row => `
                    <tr>
                      <td style="padding: 6px;">${row.source}</td>
                      <td style="padding: 6px;">${row.husband ?? "0.00"}</td>
                      <td style="padding: 6px;">${row.wife ?? "0.00"}</td>
                      <td style="padding: 6px;">${row.adult ?? "0.00"}</td>
                      <td style="padding: 6px;">${row.other ?? "0.00"}</td>
                    </tr>`).join("")}
                </tbody>
              </table>`
            : "<p style=\"margin: 8px 0 16px 0;\">No financial information available.</p>"
        }
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />


        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Address Information</h2>
        ${
          data.addresses && data.addresses.length
            ? data.addresses.map((a, i) => `
              <h3 style="margin: 12px 0 6px 0;">Address ${i + 1}</h3>
              <p style="margin: 6px 0;"><strong>Line 1:</strong> ${a.line1 ?? "N/A"}</p>
              <p style="margin: 6px 0;"><strong>Type:</strong> ${a.type ?? "N/A"}</p>
              <p style="margin: 6px 0;"><strong>Suburb:</strong> ${a.suburb ?? "N/A"}</p>
              <p style="margin: 6px 0;"><strong>City:</strong> ${a.city ?? "N/A"}</p>
              <p style="margin: 6px 0 12px 0;"><strong>Postal Code:</strong> ${a.postalCode ?? "N/A"}</p>
            `).join("")
            : "<p style=\"margin: 8px 0 16px 0;\">No address information provided.</p>"
        }
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Employment Information</h2>
        ${
          data.employmentList && data.employmentList.length
            ? `<ul style="margin: 8px 0 16px 20px; padding-left: 0;">${data.employmentList.map((e, i) =>
                `<li style="margin-bottom: 6px;"><strong>Employer ${i + 1}:</strong> ${e.EmpName ?? "N/A"} | Position: ${e.EmpPosition ?? "N/A"}</li>`
              ).join("")}</ul>`
            : "<p style=\"margin: 8px 0 16px 0;\">No employment history recorded.</p>"
        }
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Contact Information</h2>
        ${
          data.contacts && data.contacts.length
            ? `<ul style="margin: 8px 0 16px 20px; padding-left: 0;">${data.contacts.map((c, i) =>
                `<li style="margin-bottom: 6px;"><strong>Contact ${i + 1}:</strong> ${c.Number ?? "N/A"} | Type: ${c.TypeDescription ?? "N/A"}</li>`
              ).join("")}</ul>`
            : "<p style=\"margin: 8px 0 16px 0;\">No contact information provided.</p>"
        }
        <hr style="margin: 20px 0; border: none; border-top: 1px solid #ccc;" />

        <h2 style="background-color: #f0f0f0; padding: 6px 10px; color: #2e7d32; border-left: 4px solid #2e7d32;">Supporting Documents</h2>
        ${
          data.supportingDocuments && data.supportingDocuments.length
            ? `<ul style="margin: 8px 0 16px 20px; padding-left: 0;">${data.supportingDocuments.map((doc, i) =>
                `<li style="margin-bottom: 6px;"><strong>Type:</strong> ${doc.documentType ?? "N/A"}<br /><strong>File:</strong> ${doc.fullFileName ?? doc.fileName ?? "N/A"}</li>`
              ).join("")}</ul>`
            : "<p style=\"margin: 8px 0 16px 0;\">No documents uploaded.</p>"
        }
      </div>
    `;

    // Use html2pdf.js to generate the PDF
    const options = {
      margin: [10, 10, 10, 10],
      filename: `${data.firstNames}_${data.surName}_Application.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .set(options)
      .from(pdfContent)
      .save()
      .catch((err) => {
        console.error("Error generating PDF:", err);
        message.error("Failed to export PDF");
      });
  };

  handleExportPDF();
}